import { render, staticRenderFns } from "./StoreItemMultiRegist.vue?vue&type=template&id=3520b536&"
import script from "./StoreItemMultiRegist.vue?vue&type=script&lang=js&"
export * from "./StoreItemMultiRegist.vue?vue&type=script&lang=js&"
import style0 from "./StoreItemMultiRegist.vue?vue&type=style&index=0&id=3520b536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports